import React, { useEffect } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { IndexField, ValueFieldType } from '../Types';
import Cookies from 'js-cookie';
import { FieldValidationErrors } from './FieldValidationErrors';
import { getFormFieldAriaProps, getFormFieldHelperTextId, handleOnChangeWithEvent } from '../Functions';
import { EventType } from 'lib/enum';

export const CheckboxWithHtml = (props: ValueFieldProps) => {
  const { errors, field, value, onChange, isValid } = props;
  const indexField = field.indexField as IndexField | undefined;
  const formId = getFormId(indexField?.name);
  const targetFieldName = String(field.model.targetFieldName ?? '');

  const cookieName = createCookieName(formId, targetFieldName);
  const { cssClass, title, helpText } = field.model;

  const valueField = field.valueField as ValueFieldType;
  const { id, name } = valueField;

  const checkboxIsChecked = `${value}` === 'true';
  const helpTextHtml = helpText ? `${helpText}` : '';
  const helperTextId = helpTextHtml ? getFormFieldHelperTextId(field) : undefined;
  const fieldMissing = !field || field.isHidden;

  useEffect(() => {
    if (!fieldMissing) {
      setCookieValues(cookieName, checkboxIsChecked);
    }
  }, [checkboxIsChecked, cookieName, fieldMissing]);

  if (fieldMissing) {
    return null;
  }

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setCookieValues(cookieName, checkboxIsChecked);
    handleOnChangeWithEvent(
      field,
      e.target.checked ? 'checked' : 'unchecked',
      void 0,
      void 0,
      EventType.SET_CONDITIONAL_REQUIRED
    );
    onChange(name, e.target.checked, isValid, []);
  };

  return (
    <div className={`${cssClass}`}>
      <label htmlFor={`${id}`}>
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checkboxIsChecked}
          onChange={handleChange}
          {...getFormFieldAriaProps(field, errors, helperTextId)}
        />
        <span dangerouslySetInnerHTML={{ __html: `${title}` }} />
      </label>
      {helpTextHtml && (
        <div className="sc-form-helptext" id={helperTextId} dangerouslySetInnerHTML={{ __html: helpTextHtml }} />
      )}
      <FieldValidationErrors {...props} />
    </div>
  );
};

const getFormId = (indexFieldName?: string) => {
  if (!indexFieldName) return '';
  const formId = indexFieldName.split('fxb.')[1]?.split('.Fields')[0];
  return formId ?? '';
};

const createCookieName = (formId: string, targetFieldName: string) => {
  let result = targetFieldName;
  if (targetFieldName) {
    const hasComma = targetFieldName.includes(',');
    if (hasComma) {
      result = targetFieldName.replaceAll(',', '.');
    }
  }
  const cookieName = `${formId}_${result}`.toLowerCase();
  // console.log('cookieName:', cookieName);
  return cookieName;
};

const setCookieValues = (cookieName: string, value: boolean) => {
  // console.log('setting cookie:', cookieName, 'value:', value);
  Cookies.set(cookieName, value.toString(), { expires: 2 / 24 }); // Expires in 2 hours
};

export default CheckboxWithHtml;
